import React, {Fragment, useEffect, useState} from "react";
import {useParams} from "react-router";
import {getIndicator} from "../../services/Indicators.service";
import {uniqueId} from "lodash";
import Loading from "../../components/Loading";
import Format from "../../utils/format";
import covert from "../../utils/convert";
import {getTable} from "../../services/Tables";

const PreviewIndicator = ({update}) => {

    let {id} = useParams();
    const [data, setData] = useState({})
    const [tables, setTables] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        ( async () => {
            if(id) {
                const response = await getIndicator(id)
                setData(response)
                if(response?.tables) {
                    setTables(response.tables)
                }
            }
            setLoading(false)
        })()
    }, [update])

    const getTableId = async (tableId) => {
        return await getTable(tableId)
    }

    const formatColumn = async (unit, unit_convert, index, position, indexTable, tableId) => {

        const tableRows = await getTableId(tableId)
        const rows = [...tables];

        rows[indexTable].rows.map((item, itemIndex) =>
            {
                const originalValue = tableRows.rows[itemIndex][position].value

                item[position].value = covert(unit_convert?.trim(), item[position].value, unit?.trim(), originalValue)

                item[position].unit = unit_convert
            }
        )

        setTables(rows)
    }


    if (loading) return <Loading/>

    return (
        <div>
            <div className="header-page">
                <div>
                    <h1 className="text-uppercase">{data?.titulo}</h1>
                </div>

                <div className="header-tags d-flex flex-wrap gap-2 align-items-end">
                    { data?.tags?.ods?.map(item =>
                        <img
                            key={item.name}
                            src={window.location.origin + `/assets/img/certificados/ODS_${item.name}.png`}
                            alt={`ODS_${item.name}`}
                            width={72}
                        />
                    )}
                    { data?.tags?.dimensao_sasb?.map((item, index) =>
                        <div className="box-tag" key={index}>
                            <p>Dimensão SASB</p>
                            <span key={index}>{item.name}</span>
                        </div>
                    )}

                    { data?.tags?.codigo_sasb?.map((item, index) =>
                        <div className="box-tag" key={index}>
                            <p>Código SASB</p>
                            <span key={index}>{item.name}</span>
                        </div>
                    )}

                    { data?.tags?.setor_sasb?.map((item, index) =>
                        <div className="box-tag" key={index}>
                            <p>Setor SASB</p>
                            <span key={index}>{item.name}</span>
                        </div>
                    )}

                    { data?.tags?.dimensao_gri?.map((item, index) =>
                        <div className="box-tag" key={index}>
                            <p>Dimensão GRI</p>
                            <span key={index}>{item.name}</span>
                        </div>
                    )}

                    { data?.tags?.codigo_gri?.map((item, index) =>
                        <div className="box-tag" key={index}>
                            <p>Código GRI</p>
                            <span key={index}>{item.name}</span>
                        </div>
                    )}

                    { data?.tags?.dim_m_c_stakeholder?.map((item, index) =>
                        <div className="box-tag" key={index}>
                            <p>Stakeholder</p>
                            <span key={index}>{item.name}</span>
                        </div>
                    )}

                    { data?.tags?.tcfd?.map((item, index) =>
                        <div className="box-tag" key={index}>
                            <p>Tcfd</p>
                            <span key={index}>{item.name}</span>
                        </div>
                    )}

                    { data?.tags?.flag_compromissos?.map((item, index) =>
                       item.name === 'Sim' &&
                            <div className="box-tag" key={index}>
                                <span key={index}>Compromisso para renovar a vida</span>
                            </div>
                    )}
                </div>
            </div>

            <div className="body-page">
                {data?.contexto &&
                    <div className="pb-5">
                        <div className="header-context">
                            Contexto
                        </div>
                        <div className="body-text" dangerouslySetInnerHTML={{__html: data?.contexto}}/>
                    </div>
                }

                <div className="table-area">
                    { tables.map((table, indexTable) =>
                        <Fragment key={table.id}>

                            {table?.titulo && <h4>{table?.titulo}</h4>}

                            <div className="table-responsive">
                                <table className="table table-bordered align-middle table-striped">
                                    <thead>
                                    {table.headers.map((head, index) => {

                                        const group = index === 0 && head.reduce((headers, header) => {
                                            if (!headers[header.value]) {
                                                headers[header.value] = 0
                                            }
                                            headers[header.value]++;
                                            return headers;
                                        }, {});

                                        let values = [];

                                        if (index === 0) {
                                            { head?.map((column, position) => {
                                                   if (!values.includes(column.value)){
                                                       values.push(column.value)
                                                   }
                                            })}
                                       }
                                        return index === 0 ? (
                                            <tr key={index}>
                                                { values?.map((column, position) =>
                                                    <th className="text-center fw-bolder"
                                                        colSpan={group[column]} key={`group-${position}`}>
                                                        {column}
                                                    </th>
                                                )}
                                            </tr>
                                        ) : (
                                            <tr key={index}>
                                                {head?.map((column, position) =>
                                                    <th className="text-center fw-bolder" key={position}>
                                                        {column.value}
                                                    </th>
                                                )}
                                            </tr>
                                        )
                                    })}

                                    { table.rows.map((row, index) =>
                                        <Fragment key={index}>
                                            {index === 0 &&
                                                <tr className="bg-light">
                                                    { row.map((item, position) => {
                                                        const units_convert = item.unit_convert && item?.unit_convert.split(";")
                                                        return (
                                                            <th key={position} className="text-center"
                                                                style={{minWidth: "200px"}}>
                                                                { position > 0 && units_convert ?
                                                                    <select
                                                                        className="form-select rounded-0"
                                                                        defaultValue={item.unit}
                                                                        value={item.unit}
                                                                        onChange={(e) => formatColumn(item.unit, e.target.value, index, position, indexTable, table.id)}>
                                                                        <option key={item.unit} value={item.unit} >{item.unit?.trim()}</option>
                                                                        { units_convert?.map(unit => {
                                                                            if(unit?.trim() !== item.unit?.trim()) {
                                                                                return (<option key={unit} value={unit} selected={unit === item.unit}>{unit?.trim()}</option> )
                                                                            }
                                                                        }
                                                                        )}
                                                                    </select>
                                                                    : position > 0 && item.unit
                                                                }
                                                            </th>
                                                        )
                                                    }

                                                    )}
                                                </tr>
                                            }
                                        </Fragment>
                                    )}
                                    </thead>

                                    <tbody>
                                    {table.rows.map((row, index) => (
                                        <tr className="bg-light" key={`body-${index}`}>
                                            {row.map((item, position) =>
                                                <td  key={uniqueId()}
                                                    className={`${position === 0 ? 'text-start' : 'text-end'} preview-data`}
                                                    style={{minWidth: "200px"}}>
                                                    <Format
                                                        value={item.value}
                                                        unit={item.unit}
                                                        editInputRow={() => {}}
                                                        rowPosition={() => {}}
                                                        position={position}
                                                        displayType={'text'}
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="table-footer">
                                <div dangerouslySetInnerHTML={{__html: table.footer}}/>
                            </div>
                        </Fragment>
                    )}
                </div>
            </div>
            { data?.informacoes_complementares &&
                <div className="footer-page">
                    <div className="header-footer">
                        Informações complementares
                    </div>

                    <div className="text-footer">
                        <div className="py-5 px-4"
                             dangerouslySetInnerHTML={{__html: data?.informacoes_complementares}}
                        />
                    </div>
                </div>
            }
        </div>
    )
}

export default PreviewIndicator
